import ConstructorIOClient from '@constructor-io/constructorio-client-javascript'
import { getConstructorIndex } from '../helpers/constructor'

const constructorClientInstances = new Map<string, ConstructorIOClient>()
const constructorNodeInstances = new Map<string, any>()

type ConstructorInstanceParams = {
  userId: string
}

export const getConstructorInstanceClientSide = ({ userId }: ConstructorInstanceParams) => {
  const key = userId

  if (!constructorClientInstances.has(key)) {
    const segments =
      typeof window !== 'undefined' && Array.isArray(window?.cnstrc?.userSegments)
        ? window.cnstrc.userSegments
            .map((segment) => segment?.toString())
            .filter((segmentString) => Boolean(segmentString))
        : undefined
    constructorClientInstances.set(
      key,
      new ConstructorIOClient({
        apiKey: getConstructorIndex(),
        userId: Boolean(userId) && userId !== '0' ? userId : undefined,
        segments,
      })
    )
  }

  return constructorClientInstances.get(key)!
}

export const getConstructorInstanceServerSide = ({ userId }: ConstructorInstanceParams) => {
  // the window condition is required to not have an error of trying to require this library in client side and breaking the build
  const ConstructorIONode =
    typeof window === 'undefined' ? require('@constructor-io/constructorio-node') : null
  const key = userId

  if (!constructorNodeInstances.has(key)) {
    constructorNodeInstances.set(
      key,
      new ConstructorIONode({
        apiKey: getConstructorIndex(),
        userId: Boolean(userId) && userId !== '0' ? userId : undefined,
      })
    )
  }

  return constructorNodeInstances.get(key)!
}
